import { ObjectModel } from 'objectmodel';

const Command = new ObjectModel({
  id: String,
  action: String
});

export { Command };



/** WEBPACK FOOTER **
 ** ./~/kaistore-post-messenger/src/models/Command.js
 **/